// Column definitions + persistence for the 仕入先 (Suppliers) table.
export const LS_KEY = 'mfg_suppliers_cols_v1';

// order here = the default column order. fixed:true → cannot be hidden (mobile card title).
export const COLUMN_DEFS = [
  { key: 'name', labelKey: 'mfg.supplier.name', defaultOn: true, fixed: true },
  { key: 'type', labelKey: 'mfg.supplier.type', defaultOn: true },
  { key: 'code', labelKey: 'mfg.supplier.code', defaultOn: true },
  { key: 'contact', labelKey: 'mfg.supplier.contact', defaultOn: true },
  { key: 'email', labelKey: 'mfg.supplier.email', defaultOn: true },
  { key: 'phone', labelKey: 'mfg.supplier.phone', defaultOn: true },
  { key: 'fax', labelKey: 'mfg.supplier.fax', defaultOn: true },
  { key: 'kana', labelKey: 'mfg.supplier.kana', defaultOn: false },
  { key: 'short_name', labelKey: 'mfg.supplier.shortName', defaultOn: false },
  { key: 'zip', labelKey: 'mfg.supplier.zip', defaultOn: false },
  { key: 'invoice_reg_no', labelKey: 'mfg.supplier.invoiceRegNo', defaultOn: false },
  { key: 'address', labelKey: 'mfg.supplier.address', defaultOn: false },
  { key: 'bank', labelKey: 'mfg.supplier.bankName', defaultOn: false },
];

const FIXED_KEYS = new Set(COLUMN_DEFS.filter((d) => d.fixed).map((d) => d.key));
const KNOWN_KEYS = new Set(COLUMN_DEFS.map((d) => d.key));

export function defaultConfig() {
  return {
    columns: COLUMN_DEFS.map((d) => ({ key: d.key, visible: d.defaultOn })),
    sort: { key: null, dir: 'asc' },
  };
}

// Merge a saved config with the current defs so newly-added columns appear and
// removed columns drop out; keeps the user's order + visibility + default sort.
export function normalizeConfig(saved) {
  const base = defaultConfig();
  if (!saved || typeof saved !== 'object') return base;
  const savedCols = Array.isArray(saved.columns) ? saved.columns.filter((c) => c && KNOWN_KEYS.has(c.key)) : [];
  const present = new Set(savedCols.map((c) => c.key));
  COLUMN_DEFS.forEach((d) => { if (!present.has(d.key)) savedCols.push({ key: d.key, visible: d.defaultOn }); });
  savedCols.forEach((c) => { if (FIXED_KEYS.has(c.key)) c.visible = true; });
  const dir = saved.sort && saved.sort.dir === 'desc' ? 'desc' : 'asc';
  const key = saved.sort && KNOWN_KEYS.has(saved.sort.key) ? saved.sort.key : null;
  return { columns: savedCols, sort: { key, dir } };
}

export function loadConfig() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) return normalizeConfig(JSON.parse(raw));
  } catch { /* ignore */ }
  return defaultConfig();
}
